import React, { useEffect, useMemo } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setLocation, fetchLocal, setLocalActiveTab } from "../content/local"; // ✅ bring in setLocalActiveTab
import TagBar from "../components/TagBar";
import LocalTabs from "./LocalTabs";
import LocalContent from "./LocalContent";

export default function LocalsPage() {
  const { label: labelFromRoute } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // current store location
  const { city, county, state, label: storeLabelRaw } =
    useSelector((s) => s.local?.location) || {};

  // parse ?tab=
  const search = new URLSearchParams(location.search);
  const tabFromQuery = search.get("tab");

  // fallback label if route label missing
  const fallbackLabel = useMemo(
    () => (city || county || state || storeLabelRaw || "California").trim(),
    [city, county, state, storeLabelRaw]
  );

  const effectiveLabel = (labelFromRoute ?? "").trim() || fallbackLabel;
  const effectiveTab = (tabFromQuery || "news").trim();

  // normalize URL, sync store, fetch content, set tab
  useEffect(() => {
    if (!effectiveLabel) return;

    const desired = `/local/${encodeURIComponent(effectiveLabel)}?tab=${effectiveTab}`;
    const current = `${location.pathname}${location.search}`;
    if (current !== desired) {
      navigate(desired, { replace: true });
    }

    dispatch(setLocation({ label: effectiveLabel }));
    dispatch(fetchLocal({ label: effectiveLabel }));
    dispatch(setLocalActiveTab(effectiveTab));
  }, [effectiveLabel, effectiveTab, location.pathname, location.search, navigate, dispatch]);

  return (
    <>
      <TagBar />
      <LocalTabs />
      <LocalContent />
    </>
  );
}